document.addEventListener('change', function(e) {
    if (e.target.matches('input[type="radio"][data-variant-id]')) {
        var swatch = e.target;
        var sectionId = swatch.getAttribute('data-section-id');
        var variantId = swatch.getAttribute('data-variant-id');
        var card = swatch.closest(`.card-product-custom-div[data-section-id="${sectionId}"]`);
        
        if (!card) return;

        // Get data from attributes first (more reliable for AJAX)
        var variantData = {
            imageUrl: swatch.getAttribute('data-image-url'),
            productUrl: swatch.getAttribute('data-product-url')
        };

        // Fallback to variantDataMap if attributes are missing
        if (!variantData.imageUrl || !variantData.productUrl) {
            var variantDataMap = window['variantDataMap' + sectionId.replace(/-/g, '_')];
            if (variantDataMap && variantDataMap[variantId]) {
                variantData = variantDataMap[variantId];
            }
        }

        if (!variantData || !variantData.imageUrl) {
            console.log('No data found for variant:', variantId);
            return;
        }

        // Update the product image logic
        var productImageElement = card.querySelector('.card__media img');
        if (productImageElement) {
            var lazyLoadAllVariants = card.getAttribute('data-lazy-load-all-variants') === 'true';
            if (lazyLoadAllVariants) {
                var preloadedImage = card.querySelector(`img[data-variant-id="${variantId}"]`);
                if (preloadedImage) {
                    productImageElement.src = preloadedImage.src;
                    productImageElement.srcset = preloadedImage.srcset;
                }
            } else {
                var dynamicSrcset = [
                    variantData.imageUrl + (variantData.imageUrl.includes('?') ? '&' : '?') + 'width=165 165w',
                    variantData.imageUrl + (variantData.imageUrl.includes('?') ? '&' : '?') + 'width=360 360w',
                    variantData.imageUrl + (variantData.imageUrl.includes('?') ? '&' : '?') + 'width=533 533w',
                    variantData.imageUrl + (variantData.imageUrl.includes('?') ? '&' : '?') + 'width=720 720w',
                    variantData.imageUrl + (variantData.imageUrl.includes('?') ? '&' : '?') + 'width=940 940w',
                    variantData.imageUrl + (variantData.imageUrl.includes('?') ? '&' : '?') + 'width=1066 1066w'
                ].join(', ');
                productImageElement.srcset = dynamicSrcset;
                productImageElement.src = variantData.imageUrl;
            }
        }

        // Update the product URL
        var productLinks = card.querySelectorAll('a[id^="CardLink-"], a[id^="StandardCardNoMediaLink-"]');
        productLinks.forEach(function(link) {
            link.href = variantData.productUrl;
        });
    }
});
